import { GradeClassMarkStudentApi, Student } from '@/plugins/api'
const namespaced = true

const state = {
  markStudents: [],
  count: 0,
  students: [],
}

const actions = {
  async fetchMarkStudents({ commit }, params) {
    const res = await GradeClassMarkStudentApi.fetch(params)
    commit('setMarkStudents', res || [])
    return res || []
  },
  async countMarkStudents({ commit }, params) {
    const res = await GradeClassMarkStudentApi.count(params)
    commit('setCount', res || 0)
    return res || 0
  },
  async createMarkStudent({ commit }, params) {
    const res = await GradeClassMarkStudentApi.create(params)
    commit('addToMarkStudents', res || {})
  },
  async createManyMarkStudents({ commit }, params) {
    const res = await GradeClassMarkStudentApi.createMany(params)
    commit('addToMarkStudents', res || [])
  },
  async updateMarkStudent(_, { id, ...params }) {
    await GradeClassMarkStudentApi.update(id, params)
  },
  async updateManyMarkStudents(_, params) {
    await GradeClassMarkStudentApi.updateMany(params)
  },
  async removeMarkStudent(_, id) {
    await GradeClassMarkStudentApi.remove(id)
  },
  reset({ commit }) {
    commit('setMarkStudents', [])
    commit('setCount', 0)
  },
  async fetchMarkStudentsIndependent(_, params) {
    const res = await GradeClassMarkStudentApi.fetch(params)
    return res || []
  },
  async fetchReportMarkStudentIndependent(_, params) {
    const res = await GradeClassMarkStudentApi.reportMarkStudent(params)
    return res || []
  },
  async fetchStudents({commit}, params) {
    const res = await Student.fetch(params)
    commit('setStudents', res)
  }
}

const mutations = {
  setMarkStudents(state, markStudents) {
    state.markStudents = markStudents
  },
  setCount(state, count) {
    state.count = count
  },
  addToMarkStudents(state, data) {
    if (Array.isArray(data) && data.length) {
      state.markStudents = [...state.markStudents, ...data]
    } else {
      state.markStudents.push(data)
    }
  },
  updateMarkStudents(state, data) {
    const found = state.markStudents.findIndex((x) => x.id === data.id)
    if (found > -1) state.markStudents.splice(found, 1, data)
  },
  setStudents(state, students) {
    state.students = students
  },
}

const getters = {
  getMarkStudents: (state) => state.markStudents,
  getCount: (state) => state.count,
  getStudents: (state) => state.students,
}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters,
}
